import React from 'react'
import { Modal } from 'react-bootstrap'
import { useTranslation } from 'react-i18next'
import './CookieConsent.scss'
import { Link } from 'react-router-dom'

interface PagePros {
  decisionTaken: () => void
}

const CookieConsent = ({ decisionTaken }: PagePros) => {
  const { t } = useTranslation()

  const accept = () => {
    localStorage.setItem('ha_cookie', 'true')
    decisionTaken()
  }

  const decline = () => {
    localStorage.setItem('ha_cookie', 'false')
    decisionTaken()
  }
  return (
    <div className='cookie-consent-wrapper position-fixed'>
      <div className='cookie-consent'>
        <Modal.Header className='bg-white'>
          <p className='post-card-title'>{t('cookie_consent.title')}</p>
        </Modal.Header>
        <Modal.Body className='cookie-card-padding pt-2 card-font-size'>
          <div className='py-2'>
            <p>
              {t('cookie_consent.description')} <Link target='_blank' to='/datenschutzrichtlinien'>{t('cookie_consent.legal_page')}</Link>
            </p>
          </div>
          <div className='d-flex justify-content-around'>
            <button className='payment-button-cancel' onClick={decline}>
              {t('cookie_consent.decline')}
            </button>
            <button className='payment-button-tryagain' onClick={accept}>
              {t('cookie_consent.accept')}
            </button>
          </div>
        </Modal.Body>
      </div>
      <div className='backgroundBlur' />
    </div>
  )
}

export default CookieConsent
